
export enum InvoiceType{
  ISSUED = "ISSUED",
  STORNO = "STORNO",
  CANCELLED = "CANCELLED"
}
